import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  useLocation,
  useNavigate,
//  useSearchParams
} from "react-router-dom";

import {
  //Alert,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row
} from 'react-bootstrap';

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Fade from "@mui/material/Fade";

import useToken from '../hooks/useToken';
import useUser from '../hooks/useUser';

import LoginAction from '../actions/LoginAction';

import '../App.css';

export default function Login() {
  const { token, setToken } = useToken();
  const { user, setUser } = useUser();

  const navigate = useNavigate();
  const location = useLocation();

  const [username, setUserName] = useState();
  const [password, setPassword] = useState();

  //console.log(location.state) 
  //const [searchParams, setSearchParams] = useSearchParams();
  
  const [showAlertError, setShowAlertError] = useState(false);
  const [showAlertLogout, setShowAlertLogout] = useState(location.state && location.state.action && location.state.action == 'logout' ? true : false);
  window.history.replaceState({}, document.title)

  const handleSubmit = async e => {
    e.preventDefault();
    const response = await LoginAction({
      username,
      password
    });

    if(!!response.data && !!response.data.token && typeof response.data.token === "string") {
      setToken(response.data.token);
      setUser(response.data);
      if (response.data.is_shop === false) navigate("/customer/dashboard");
      if (response.data.is_shop === true) navigate("/merchant/dashboard");      
    } else {
      setShowAlertError(true);
    }
  }

  return (
    <Container fluid className="text-start mt-3 mt-md-5">
      <Row>
        <Col></Col>
        <Col xs={12} sm={8} md={4}>
          <div className="w-100 mb-1 text-center"><Card.Link href="/register">Register here</Card.Link> or login below</div>
          { showAlertLogout && 
            <Fade
               in={showAlertLogout}
               addEndListener={() => {
                 setTimeout(() => {
                   setShowAlertLogout(false)
                 }, 2000);
               }}
               >
              <Alert severity="success" variant="standard" icon={false} className="alert">
                <AlertTitle>You are now logged out</AlertTitle>
              </Alert>
            </Fade>
          }   
          { showAlertError && 
            <Fade
               in={showAlertError}
               addEndListener={() => {
                 setTimeout(() => {
                   setShowAlertError(false)
                 }, 2000);
               }}
               >
              <Alert severity="error" icon={false} className="alert">
                <AlertTitle>Error logging in</AlertTitle>
              </Alert>
            </Fade>
          }   
          <Card>
            <Card.Body>         
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Email address</Form.Label>
                  <Form.Control type="email" placeholder="Enter email" onChange={e => setUserName(e.target.value)} />
                </Form.Group>
                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control type="password" placeholder="Password" onChange={e => setPassword(e.target.value)} />
                </Form.Group>
                <Button variant="primary" type="submit" className="float-end">
                  Login
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
        <Col></Col>
      </Row>
    </Container>
  );
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
}